export default __webpack_public_path__ + "static/media/deliver-bag.6cba8147.gif";